import { LdTypo } from "@liquid/react";
import { ReactComponent as Attention } from "@liquid-assets/attention.svg";

import {
  StyledErrorCard,
  StyledErrorCardContent,
  StyledErrorCardHeader,
  StyledIcon,
} from "./ErrorCard.style";

interface ErrorCardProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  children?: React.ReactNode;
}

export const ErrorCard = ({ title, subtitle, children }: ErrorCardProps) => (
  <StyledErrorCard>
    <StyledErrorCardContent>
      <StyledIcon size="lg">
        <Attention />
      </StyledIcon>
      <StyledErrorCardHeader variant="h3">{title}</StyledErrorCardHeader>
      <LdTypo variant="h3">{subtitle}</LdTypo>
      {children}
    </StyledErrorCardContent>
  </StyledErrorCard>
);
